export default "__VITE_ASSET__1dbb5c4c__"